
import React from "react";
import "./Events.css";
import Footer from "../components/commonComponents/footer";
import TopNavbar from "../components/commonComponents/Navbar/Navbar";

const Events = () => {
    // Fixed event date
    const eventDate = new Date(2026, 8, 29); // September 29, 2026

    // Generate day automatically
    const eventDay = eventDate.toLocaleDateString("en-US", {
        weekday: "long",
    });

    // Generate date automatically
    const formattedDate = eventDate.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
    });

    // Fixed event time
    const eventTime = "11:00 a.m. IST";

    // Dynamic document details
    const documentTitle = "Annual Return (MGT-7)";
    const documentDate = "29 September, 2026";

    const annualReturnPdf =
        "https://s3.ap-south-1.amazonaws.com/yourfarm.in/Animeta_MGT-7A_2025-26.pdf";

    const handlePdfClick = () => {
        window.open(annualReturnPdf, "_blank", "noopener,noreferrer");
    };

    return (
        <>
            <TopNavbar />

            <div className="events-page">
                <div className="events-container">

                    {/* Event Details */}
                    <h2 className="events-section-title">
                        Event Details
                    </h2>

                    <p className="events-description">
                        Animeta to hold its 4th Annual General Meeting on{" "}

                        {eventDay}, {formattedDate} at {eventTime}.

                        through Video Conferencing (“VC”) / Other Audio Visual
                        Means (“OAVM”).
                    </p>

                    {/* Related Documents */}
                    <p className="events-related-title">
                        Following are the related documents:
                    </p>


                    <ul className="events-document-list">
                        <li>
                            <span
                                className="events-document-link"
                                onClick={handlePdfClick}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        handlePdfClick();
                                    }
                                }}
                            >
                                {documentTitle}
                            </span>

                            <span className="events-document-open">
                                &nbsp; - {documentDate}
                            </span>
                        </li>
                    </ul>


                </div>
            </div>

            <div style={{ margin: "2rem 0" }}></div>

            <Footer />
        </>
    );
};

export default Events;
